// extracted by mini-css-extract-plugin
export var admin = "comment-module--admin--b1c58";
export var answer = "comment-module--answer--47d32";
export var answerButton = "comment-module--answer-button--7a9fa";
export var avatar = "comment-module--avatar--09ebb";
export var bottom = "comment-module--bottom--3ab67";
export var container = "comment-module--container--f3d12";
export var content = "comment-module--content--41fc7";
export var contentColumn = "comment-module--content-column--a6ee6";
export var date = "comment-module--date--3e484";
export var deleteImageButton = "comment-module--delete-image-button--47124";
export var deleted = "comment-module--deleted--15d60";
export var dot = "comment-module--dot--5b5f1";
export var dropdownButton = "comment-module--dropdown-button--3683d";
export var fields = "comment-module--fields--9ac09";
export var fileInput = "comment-module--file-input--04c08";
export var fileInputLabel = "comment-module--file-input-label--b3a76";
export var form = "comment-module--form--13580";
export var formActions = "comment-module--form-actions--6b719";
export var formButton = "comment-module--form-button--84bb1";
export var header = "comment-module--header--b9d15";
export var image = "comment-module--image--92ebb";
export var imageBox = "comment-module--image-box--7db83";
export var imageButton = "comment-module--image-button--662a9";
export var images = "comment-module--images--3c17a";
export var input = "comment-module--input--94a02";
export var inputBox = "comment-module--input-box--34642";
export var name = "comment-module--name--6c2cc";
export var nameBox = "comment-module--name-box--40fa8";
export var text = "comment-module--text--8128b";
export var yours = "comment-module--yours--6c4c5";